<base-index-page
  [config]="baseIndexPageConfig"
  [service]="deleteService"
  [idKey]="'regulatorId'"
></base-index-page>
